// extracted by mini-css-extract-plugin
module.exports =  {"modalContentWrapper":"modalContentWrapper__f5I4k","modalActions":"modalActions__8r2Qa","copyMessage":"copyMessage__K651P"};